import groupBy from 'lodash/groupBy';
import dayjs from 'dayjs';
import { Toast } from 'antd-mobile';
import { storage, EnumCacheKey } from '@/utils/storage';
import { imageCompress } from '@/utils/file';
import { getUrlParams } from '@/utils/env';
import { getAuthStr } from '@/utils/url';

/**
 * 对话上下文消息
 */
export const formatLastMessagesContext = () => {
  const messages = storage.getItem(`app/ai/${getUrlParams('roleId')}/history`);
  const list = (messages || []).filter(
    (item) =>
      item.type === 'text' && // 文字消息
      item.chatType === 0 && // 文字类型提问和回答
      item.content?.text &&
      !/^error/.test(item.content?.text) // 有文字内容，且不是error开头
  );

  return list.slice(-4).map(({ type, position, content }) => {
    let from = 1; // 0：user，1：gpt

    if (position === 'right') {
      from = 0;
    }

    const text = encodeURIComponent(content?.text || '');

    return `${from}#@#${text}`;
  });
};

export const fetchHistoryMessages = (roleActive) => {
  // 35 天内的消息
  const limitTime = Date.now() - 35 * 24 * 60 * 60 * 1000;
  let messages = storage.getItem(`app/ai/${roleActive}/history`);

  if (messages) {
    messages?.map((item) => {
      console.log('itemitemitem', item);

      if (item?.user?.avatar) {
        item.user.avatar = getAuthStr(item?.user?.avatar, 1);
      }
    });
    return messages.filter((item) => {
      return item.createdAt > limitTime;
    });
  }

  return messages;
};

export const groupHistory = (arr) => {
  return groupBy(arr, (item) => dayjs(item.createTime).format('YYYY.MM.DD'));
};

export const formtImg2Imgs = (img) => {
  if (!img) return null;

  if (Array.isArray(img)) return img;

  return [img];
};

export const serverTimeCreater = {
  timeDiff: 0,
  timeDiffReady: false,
  timeServer: function () {
    if (this.timeDiffReady) {
      return Date.parse(new Date()) / 1000 - this.timeDiff;
    }

    return '';
  },
  update: function () {}
};

if (typeof window !== 'undefined') {
  serverTimeCreater.update();
}

export const ensureImagesCompress = (imgs) => {
  if (!imgs || imgs.length === 0) return Promise.reject();

  return Promise.all(imgs.map((item) => imageCompress(item)));
};

export const isIdentifyEmpty = (data) => {
  return (
    !data?.commonName &&
    !data?.botanicalName &&
    !data?.family &&
    !data?.plantType &&
    !data?.lifespan &&
    !data?.propagation &&
    !data?.nativeDistribution &&
    !data?.temperature &&
    !data?.lightPreference &&
    !data?.soil &&
    !data?.plantGrowthRate &&
    !data?.planting &&
    !data?.care &&
    !data?.commonDisease
  );
};

/**
 * 是否WhoAreYou类似的问句
 */
export const isLikeWhoAreYou = (str) => {
  const strtemp = (str || '').replace(/[\s|.|?]+$/g, '');

  if (!str) return false;

  return (
    [
      'who are you',
      'who are you really',
      "Who's this",
      'Mind sharing your name',
      'Could you  tell me again',
      'Can you tell me a bit about yourself',
      'What is your identity',
      'Who do you claim to be',
      'Can you introduce yourself',
      'What is your name and background',
      'Tell me about yourself',
      'Could you please identify yourself'
    ].indexOf(strtemp) > -1
  );
};

/**
 * 生成随机的延迟时间和单词数量
 * @param {number} n - 输入参数
 * @returns {Object} 一个包含随机延迟时间和单词数量的对象
 */
export const randomDelayAndWords = (n) => {
  // 最小延迟时间（毫秒）
  const minDelay = 100;
  // 最大延迟时间（毫秒）
  const maxDelay = 300;

  // 根据输入参数 n 计算最小单词数量，取 n 的平方根再除以 3，并向下取整
  const minWords = Math.floor(Math.sqrt(n) / 3);
  // 根据输入参数 n 计算最大单词数量，取 n 的平方根再乘以 1.2，并向下取整
  const maxWords = Math.floor(Math.sqrt(n) * 1.2);

  // 定义一个函数，用于生成服从指数分布的随机数
  const expDistribution = (min, max, lambda) => {
    // 生成服从指数分布的随机数
    const u = Math.random() ** lambda;
    // 返回在给定范围内的服从指数分布的随机整数
    return Math.floor(u * (max - min + 1)) + min;
  };

  // 生成随机的延迟时间，以指数分布为基础，参数 lambda 为 2
  const delay = expDistribution(minDelay, maxDelay, 2);
  // 生成随机的单词数量，以指数分布为基础，参数 lambda 为 0.5
  const words = expDistribution(minWords, maxWords, 0.5);

  // 返回随机生成的延迟时间和单词数量
  return { delay, words };
};

/**
 * Lover角色自动回复逻辑
 */
export const quickRepliesControl = {
  answer: (item) => {
    const cacheClickedItems = storage.getItem(`app/cache/autoreply/${getUrlParams('roleId')}`) || {};
    cacheClickedItems[item.name] = 1;

    storage.setItem(`app/cache/autoreply/${getUrlParams('roleId')}`, cacheClickedItems);

    if (item.answerType === 'image') {
      return {
        type: 'image',
        content: {
          picUrl: item.answer
        }
      };
    }
    if (item.answerType === 'video-dancing') {
      return {
        type: 'video',
        content: item.answer
      };
    }

    return {
      type: 'text',
      content: {
        text: item.answer[Math.floor(Math.random() * item.answer.length)]
      }
    };
  },
  filter: (list) => {
    const cacheClickedItems = storage.getItem(`app/cache/autoreply/${getUrlParams('roleId')}`) || {};

    return list.filter((item) => {
      return !cacheClickedItems[item.name];
    });
  }
};

// 用户使用功能行为记录
export const userBehaveRecord = {
  set: (val, behaveFor = 'vip') => {
    storage.setItem(EnumCacheKey['app/dots/func'] + '/' + behaveFor, val);
  },
  get: (behaveFor = 'vip') => {
    return storage.getItem(EnumCacheKey['app/dots/func'] + '/' + behaveFor);
  },
  remove: (behaveFor = 'vip') => {
    return storage.removeItem(EnumCacheKey['app/dots/func'] + '/' + behaveFor);
  }
};

export const getStoryDetail = (item) => {
  const dataInfo = item || storage.getItem(EnumCacheKey['app/boon/detail']) || {};
  try {
    return dataInfo;
  } catch (err) {
    return {};
  }
};

export const formatDaliyList = (list) => {
  return list.map((item, index) => {
    return {
      ...item,
      dateString: dayjs().add(index, 'day').format('YYYY-MM-DD')
    };
  });
};

/**
 * 故事点赞数格式化
 * @param {*} num
 * @returns
 */
export const formatLikeNum = (num) => {
  if (num < 1000) {
    return num;
  }

  return (num / 1000).toFixed(1) + 'K';
};

let toastInstance = null;
export const showPageLoading = () => {
  toastInstance = Toast.show({
    icon: 'loading',
    content: 'loading…',
    duration: 0
  });
};

export const hidePageLoading = () => {
  if (toastInstance) {
    try {
      toastInstance.close();
      toastInstance = null;
    } catch (err) {}
  }
};
